export const findById = (group, id) => group && group.find((c) => c.contentful_id === id)
